module.exports = __webpack_public_path__ + "lptGlobal/img/interiors-spinner.da7693b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/global/images/logos/interiors-spinner.svg
// module id = NcwD
// module chunks = 1